// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"ba70d988","76":"7d4d0748","112":"67bf7f82","182":"c0204874","194":"6b9758ba","245":"068fc7d1","313":"9b94e218","719":"10d74c14","885":"6995c223","893":"c699c255","900":"21a6e14b","958":"dc1db724"}[chunkId] + ".chunk.js";
};